module.exports = __webpack_public_path__ + "img/company3-1.240092e4.png";